<template>
  <div>
    <h3>Student Opportunities</h3>
    
    <div v-if="opportunities">
      <student-opportunities :opportunities="opportunities"></student-opportunities>
      <div v-if="!opportunities.length">No student oppoortunities were found</div>
    </div>
  </div>  
</template>

<script>
import StudentOpportunities from "../../components/students/student-opportunity-list";
import Widget from "../../components/widget";
import studentOpportunityApi from "../../api/studentOpportunity";
import { mapState } from "vuex";

export default {
  data() {
    return {
      opportunities: null,
      pageNumber: 1,
      pageSize: 20,
      totalRows: 0,
      sortBy: "firstName",
      sortDesc: false
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {},

  components: {
    "student-opportunities": StudentOpportunities,
    widget: Widget
  },

  methods: {},

  created() {
    var that = this;
    studentOpportunityApi
      .getStudentOpportunities()
      .then(function(response) {
        that.opportunities = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}

p {
  margin-bottom: 0.3em;
}

.student-details {
  padding: 15px 5px 10px 5px;
}

.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  max-width: 100%;
}
</style>
